import { all, call, put, takeEvery } from 'redux-saga/effects';
import * as types from './weaveFactorActionTypes';
import * as actions from './weaveFactorActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getWeaveFactorSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getWeaveFactors, payload);
    yield put(actions.getWeaveFactorDataAction(data));
  } catch (e) {
    yield put(actions.getWeaveFactorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createWeaveFactorSaga(action) {
  try {
    const { data } = yield call(endpoints.createWeaveFactor, action.payload.data);
    yield put(actions.createWeaveFactorDataAction(data));
    if (data.Result?.ErrorCode === 0 && action.payload.navigate) {
      setTimeout(() => action.payload.navigate('/weavefactor'), 1000);
    }
  } catch (e) {
    yield put(actions.createWeaveFactorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateWeaveFactorSaga(action) {
  try {
    const { data } = yield call(endpoints.updateWeaveFactor, action.payload.data);
    yield put(actions.updateWeaveFactorDataAction(data));
    if (data.Result?.ErrorCode === 0 && action.payload.navigate) {
      setTimeout(() => action.payload.navigate('/weavefactor'), 1000);
    }
  } catch (e) {
    yield put(actions.updateWeaveFactorErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteWeaveFactorSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteWeaveFactor, action.payload.data);
    yield put(actions.deleteWeaveFactorDataAction(data));
    if (data.Result?.ErrorCode === 0) {
      yield put(actions.getWeaveFactorRequestAction());
    }
  } catch (e) {
    yield put(actions.deleteWeaveFactorErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* weaveFactorSaga() {
  yield all([
    takeEvery(types.GET_WEAVEFACTOR_REQUEST, getWeaveFactorSaga),
    takeEvery(types.CREATE_WEAVEFACTOR_REQUEST, createWeaveFactorSaga),
    takeEvery(types.UPDATE_WEAVEFACTOR_REQUEST, updateWeaveFactorSaga),
    takeEvery(types.DELETE_WEAVEFACTOR_REQUEST, deleteWeaveFactorSaga),
  ]);
}
